<template>
  <div v-if="hasProductionSystems">
    <SubHeader :text="$t('ARTICLE-BUNDLE-PRODUCTION_SYSTEMS')" />
    <v-simple-table dense class="productionSystems stripe-row">
      <template v-slot:default>
        <tbody>
          <tr v-for="row in bundle.productionsystems" :key="row.id">
            <td>{{ row.name }}</td>
            <td>
              <div class="productionSystems__wrapper">
                <div v-if="row.pivot.status == 'allow'" class="productionSystems__status">
                  <v-icon small class="productionSystems__item">mdi-check</v-icon>
                </div>

                <div v-else class="productionSystems__status">
                  <v-tooltip top v-if="row.info != ''">
                    <template v-slot:activator="{ on, attrs }">
                      <template v-if="row.calculationrule_id && row.calculationrule_id > 0">
                        
                      <v-icon bind="attrs" @click="showTestResult(row.calculationrule_id, bundle.id)" class="productionSystems__item" v-on="on" small>mdi-information-outline</v-icon>
                      </template>
                      <v-icon bind="attrs" v-else class="productionSystems__item" v-on="on" small>mdi-information-outline</v-icon>
                    </template>
                    <span class="infoContainer" v-html="row.info"></span>
                  </v-tooltip>
                </div>
                <div v-if="row.name === 'ADP'" class="productionSystems__group">
                  <div
                    :class="`productionSystems__item ${item.attribute.isWritable ? 'productionSystems__item--edit' : ''}`"
                    
                    v-for="(item, index) in adpList"
                    :key="index"
                    >
                    <span @click="editAttribute(item.attribute)">{{ item.attribute.displayName[$store.getters.langShortcode] }}: {{ attributeValue(item.attribute) }}</span>
                    
                  <CalculationRuleTooltip  @showTestResult="showTestResult" :bundle="bundle" :item="item" />  
                    
                    </div
                  >
                  
                </div>

                <div v-if="row.name === 'PACK MASTER'" class="productionSystems__group">
                  <div
                    :class="`productionSystems__item ${item.attribute.isWritable ? 'productionSystems__item--edit' : ''}`"
                    
                    v-for="(item, index) in packmasterList"
                    :key="index"
                    >
                    <span @click="editAttribute(item.attribute)">{{ item.attribute.displayName[$store.getters.langShortcode] }}: {{ attributeValue(item.attribute) }}</span>
                    
                    <CalculationRuleTooltip  @showTestResult="showTestResult" :bundle="bundle" :item="item" />  
                     
                    </div
                  >
                </div>
                <template v-else-if="row.name === 'PIE ROBOT'">
                  <div
                    :class="`productionSystems__item ${item.attribute.isWritable ? 'productionSystems__item--edit' : ''}`"
                    v-for="(item, index) in robotProgramList"
                    :key="index"
                    >
                    <span @click="editAttribute(item.attribute)">{{ item.attribute.displayName[$store.getters.langShortcode] }}: {{ attributeValue(item.attribute) }}</span>
                    
                    <CalculationRuleTooltip  @showTestResult="showTestResult" :bundle="bundle" :item="item" />  
                   
                    </div
                  >
                </template>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <Dialog :dialogSettings="dialog" :itemEdited="editedItem" :propBundle="bundle" @closeModal="closeModal" @changeAttribute="changeAttribute" />
  </div>
</template>

<script>
import SubHeader from "@/components/ui-elements/SubHeader.vue";
import Dialog from "./Dialog.vue";
import { EditAttributeDialogMixin } from "@/components/item/EditAttributeDialogMixin";
import { cloneDeep } from "lodash";
import CalculationRuleTooltip from "./CalculationRuleTooltip.vue";
export default {
  name: "ProductionSystem",
  mixins: [EditAttributeDialogMixin],
  components: {
    SubHeader,
    Dialog,
    CalculationRuleTooltip
  },
  props: {
    bundle: {
      type: Object,
    },
  },
  data() {
    return {
      adpList: [],
      packmasterList: [],
      robotProgramList: [],
    };
  },
  computed: {
    hasProductionSystems() {
      return this.bundle.productionsystems && this.bundle.productionsystems.length > 0;
    },
    attributeValue() {
      return (attribute) => {
        if (attribute.pivot) {
          if (attribute.pivot.override) return attribute.pivot.override;
          return attribute.pivot.value ?? '-';
        }
        return "-";
      };
    },
  },
  created() {},
  watch: {
    bundle: {
      handler() {
        this.prepareData();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    reset() {
      this.adpList = [];
      this.packmasterList = [];
      this.robotProgramList = [];
    },
    prepareData() {
      this.reset();
      const adpList = [];
      const adpProgram = this.bundle.attributesDetails.find((el) => el.attribute.name === "adp_program");
      if (adpProgram) {
        adpList.push(adpProgram);
      }
      const kisoftAdpProgram = this.bundle.attributesDetails.find((el) => el.attribute.name === "kisoft_adp_program");
      if (kisoftAdpProgram) {
        adpList.push(kisoftAdpProgram);
      }

      const kisoftAdpHandling = this.bundle.attributesDetails.find((el) => el.attribute.name === "kisoft_adp_handling");
      if (kisoftAdpHandling) {
        adpList.push(kisoftAdpHandling);
      }

      this.adpList = cloneDeep(adpList);
      const packmasterList = [];
      const nestingType = this.bundle.attributesDetails.find((el) => el.attribute.name === "nesting_type");
      if (nestingType) {
        packmasterList.push(nestingType);
      }
      const nestingBonus = this.bundle.attributesDetails.find((el) => el.attribute.name === "nesting_bonus");
      if (nestingBonus) {
        packmasterList.push(nestingBonus);
      }

      const nestingSameTypeRequired = this.bundle.attributesDetails.find((el) => el.attribute.name === "nesting_same_type_required");
      if (nestingSameTypeRequired) {
        packmasterList.push(nestingSameTypeRequired);
      }

      const nestingMixSizes = this.bundle.attributesDetails.find((el) => el.attribute.name === "nesting_mix_sizes");
      if (nestingMixSizes) {
        packmasterList.push(nestingMixSizes);
      }

      const nestingTolarancePlus = this.bundle.attributesDetails.find((el) => el.attribute.name === "nesting_tolerance_plus");
      if (nestingTolarancePlus) {
        packmasterList.push(nestingTolarancePlus);
      }

      const nestingTolaranceMinus = this.bundle.attributesDetails.find((el) => el.attribute.name === "nesting_tolerance_minus");
      if (nestingTolaranceMinus) {
        packmasterList.push(nestingTolaranceMinus);
      }
      this.packmasterList = cloneDeep(packmasterList);

      const robotProgramList = [];
      const robotProgram = this.bundle.attributesDetails.find((el) => el.attribute.name === "robot_program");
      if (robotProgram) {
        robotProgramList.push(robotProgram);
      }

      this.robotProgramList = cloneDeep(robotProgramList);
    },
     showTestResult(calculationId, bundleId) {
      this.$emit("showTestResult", calculationId, bundleId);
    }

  },
};
</script>

<style lang="scss" scoped>
.productionSystems {
  &__wrapper {
    display: flex;
  }
  &__status {
    display: flex;
    flex: 0 1 20px !important;
  }
  &__item {
    margin-right: 5em;
    cursor: default;
    display: inline-flex;

    & > *{
      padding: 0 .25em;
    }
    &--edit {
      cursor: pointer;
      // color: #343434!important;
    }
  }
  &__group {
    flex: 1;
  }
}
</style>
